import React from 'react';
import { Section } from './ui/Section';
import { FadeIn } from './ui/FadeIn';
export function MarketOpportunity() {
  return <Section background="charcoal" className="text-ivory" data-id="element-280" data-mp="1n82q38uiy0m5">
      <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-281" data-mp="1r94oxokj4anl">
        <FadeIn data-id="element-282" data-mp="1r7l5jp3ktjhl">
          <h2 className="text-4xl md:text-5xl font-serif mb-6" data-id="element-283" data-mp="1r71oealr2z4m">
            A Generational Market Shift
          </h2>
          <p className="text-lg text-ivory/70" data-id="element-284" data-mp="20yxy6ix78doo">
            Fem Entity sits at the intersection of women's economic power,
            digital health transformation, and corporate wellness evolution.
          </p>
        </FadeIn>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16" data-id="element-285" data-mp="2axdgpxi5uemk">
        <FadeIn delay={100} data-id="element-286" data-mp="2exflifj6zo62">
          <div className="glass-panel-dark p-8 rounded-2xl text-center h-full flex flex-col justify-center" data-id="element-287" data-mp="2exnvnznxkfdk">
            <div className="text-4xl md:text-5xl font-serif text-purple-400 mb-2" data-id="element-288" data-mp="gkxgpefyjwq5">
              $44B
            </div>
            <div className="text-sm uppercase tracking-widest text-ivory/50 font-medium" data-id="element-289" data-mp="1qu2idvuislkx">
              Corporate Wellness TAM
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={200} data-id="element-290" data-mp="1m19bb1bkx15o">
          <div className="glass-panel-dark p-8 rounded-2xl text-center h-full flex flex-col justify-center" data-id="element-291" data-mp="1h3zn1ozxevjf">
            <div className="text-4xl md:text-5xl font-serif text-purple-400 mb-2" data-id="element-292" data-mp="1c5oc1axwaezm">
              $8.8B
            </div>
            <div className="text-sm uppercase tracking-widest text-ivory/50 font-medium" data-id="element-293" data-mp="29rlrezgza47c">
              Serviceable Market
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={300} data-id="element-294" data-mp="1zu7lvuwleztt">
          <div className="glass-panel-dark p-8 rounded-2xl text-center h-full flex flex-col justify-center" data-id="element-295" data-mp="1ztfpihv68y2h">
            <div className="text-4xl md:text-5xl font-serif text-purple-400 mb-2" data-id="element-296" data-mp="1uv4ei3t54hio">
              9.3%
            </div>
            <div className="text-sm uppercase tracking-widest text-ivory/50 font-medium" data-id="element-297" data-mp="odhc61synpvg">
              CAGR Expansion
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={400} data-id="element-298" data-mp="37nr33j6hmrwu">
          <div className="glass-panel-dark p-8 rounded-2xl text-center h-full flex flex-col justify-center" data-id="element-299" data-mp="37kbpylwdjsy2">
            <div className="text-4xl md:text-5xl font-serif text-purple-400 mb-2" data-id="element-300" data-mp="3blor4ioiv7yn">
              $94B
            </div>
            <div className="text-sm uppercase tracking-widest text-ivory/50 font-medium" data-id="element-301" data-mp="32mtnnecv4bz1">
              Projected by 2026
            </div>
          </div>
        </FadeIn>
      </div>

      <FadeIn delay={600} data-id="element-302" data-mp="2sp5h7r5w9g11">
        <div className="text-center border-t border-ivory/10 pt-12" data-id="element-303" data-mp="2spf6tdn11l67">
          <p className="text-2xl md:text-3xl font-serif italic text-ivory/90" data-id="element-304" data-mp="2exqxtj82rctg">
            Women control <span className="text-purple-400" data-id="element-305" data-mp="2evxqe1pn0oke">$31.8T</span> in
            global discretionary spending.
          </p>
        </div>
      </FadeIn>
    </Section>;
}